import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme.spacing?.md ?? '16px'};
  height: 100%;
  min-height: 200px;
  padding: ${(props) => props.theme.spacing?.lg ?? '24px'};
  text-align: center;
  background: ${(props) => props.theme.colors?.white ?? '#ffffff'};
  border-radius: ${(props) => props.theme.borderRadius?.base ?? '8px'};
`;
